import {config} from "../config/config";
export default {
	//写入日志到localStorage
	writeLog(logContent){
		// 从localStorage中读取日志
		let logContents = JSON.parse(localStorage.getItem(config.LOG_CACHE_KEY) || "[]");
		//检查日志长度，超过100条的时候，只保留最近100条
		if (logContents.length > config.LOG_CACHE_MAX_LENGTH - 1) {
			logContents = logContents.slice(logContents.length - config.LOG_CACHE_MAX_LENGTH - 1);
		}
		logContents.push(logContent);
		//写入localStorage
		localStorage.setItem(config.LOG_CACHE_KEY, JSON.stringify(logContents));
	},
	//获取日志
	getLogs(){
		return JSON.parse(localStorage.getItem(config.LOG_CACHE_KEY) || "[]");
	}
};